import { email } from './customValidators';

export const validate = (values) => {
  const errors = {};

  if (!values.get('email')) {
    errors.email = 'Email is required';
  } else if (!email(values.get('email'))) {
    errors.email = 'Invalid email address';
  }
  return errors;
};



// WEBPACK FOOTER //
// ./app/lib/validators/recommendOfficeValidator.js